import { Box, height, padding, width } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { getProdutApi } from '../../apis/product.api'
import { getsourceApi } from '../../apis/source.api'
import AsyncDropDown from '../../components/inputs/AsyncDropDown'
import { Autocomplete, Grid2, ListItem, Paper, TextField, Typography } from '@mui/material'
import LineChartComponent from './LineChartComponent'
import GeoLocation from '../../components/inputs/Geolocation'
import { CATEGORIES } from '../../utils/constants'
import { findObjectKeyByValue, titleCase } from '../../utils/main'
import CustomInput from '../../components/inputs/CustomInputs'
import FilterSelection from './FilterSelection'
import { callApiAction } from '../../store/actions/commonAction'
import { useDispatch } from 'react-redux'
import CustomMonthPicker from '../../components/layouts/common/CustomMonthPicker'
import BarChartComponent from './BarChartComponent'
import WarrantyChart from './WarrantyChart'
import CountywiseUI from './CountywiseUI'
import ProblemWiseDataUi from './ProblemWiseDataUi'
import moment from 'moment'

const AnalysisDashboardUI = ({ filters, setFilters, chartData }) => {
    const dispatch = useDispatch();
    const [products, setProducts] = useState([]);
    const [source, setSource] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState("");
    const [selectedSources, setSelectedSources] = useState("");
    const [selectedCategories, setSelectedCategories] = useState("");
    const [loading, setLoading] = useState(false);

    console.log("object chartData", chartData);

    const fetchProducts = () => {
        setLoading(true);
        dispatch(
            callApiAction(
                async () => await getProdutApi({ category: filters?.categories }),
                (response) => {
                    setLoading(false);
                    setProducts(response?.result)
                },
                (err) => {
                    setLoading(false);
                }
            )
        );
    }

    const fetchSource = () => {
        setLoading(true);
        dispatch(
            callApiAction(
                async () => await getsourceApi({ ...filters }),
                (response) => {
                    setLoading(false);
                    setSource(response?.result);
                },
                (err) => {
                    setLoading(false);
                }
            )
        );
    }

    useEffect(() => {
        fetchProducts();
    }, [filters.category]); 
    
    useEffect(() => {
        fetchSource();
    }, []);

    const handleProductChange = (e) => {
        setFilters((prev) => ({
            ...prev,
            product_id: e.target.value,
        }));
    };

    const handleSourceChange = (e) => {
        setFilters((prev) => ({
            ...prev,
            source_id: e.target.value,
        }));
    };

    const handleCategoryChange = (e) => {
        setFilters((prev) => ({
            ...prev,
            category: e.target.value,
        }));
    };



    return (
        <Box sx={{ p: 2 }}>
            <Paper
                sx={{
                    minHeight: "85vh",
                    display: "flex",
                    height: "100%",
                }}
            >   
                <Box
                    sx={{
                        overflow: "auto",
                        height: "98%",
                        width: "15%",
                        borderRight: { md: "1px solid #E6E6E6" },
                    }}
                >
                    <FilterSelection
                        products={products}
                        handleProductChange={handleProductChange}
                        selectedProducts={selectedProducts}
                        loading={loading}
                        selectedCategories={selectedCategories}
                        setSelectedCategories={setSelectedCategories}
                        handleCategoryChange={handleCategoryChange}
                        handleSourceChange={handleSourceChange}
                        source={source}
                        setSource={setSource}
                        setSelectedSources={setSelectedSources}
                        selectedSources={selectedSources}
                        filters={filters}
                        setFilters={setFilters}
                        setSelectedProducts={setSelectedProducts}
                    />
                </Box>
                
                <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 ,width:"85%"}}>
                    <Box
                        sx={{
                            width: "100%",
                            px: { xs: 2, sm: 4 },
                            py: 2,
                            borderBottom: "2px solid #E6E6E6",
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            justifyContent: "space-between",
                            gap: 2,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: { sm: "center" },
                                gap: { xs: 2, sm: 4 },
                                flexWrap: "wrap",
                            }}
                        >
                            {(filters.city || filters.state || filters?.product_id) && <Box sx={{ borderLeft: "1px solid #E6E6E6", pl: 2 }}>
                                <Typography variant='h6' sx={{ color: "#999999", fontFamily: "Public Sans" }}>Device</Typography>
                                <Typography variant='h5' sx={{ color: "#1D013B", fontFamily: "Public Sans" }}>{filters?.productName ? filters?.productName : chartData?.Product?.products[0]?.productName ?? "NA"}</Typography>
                            </Box>}

                            <Box sx={{ borderLeft: "1px solid #E6E6E6", pl: 2 }}>
                                <Typography variant='h6' sx={{ color: "#999999", fontFamily: "Public Sans" }}>Total Queries</Typography>
                                <Typography variant='h5' sx={{ color: "#1D013B", fontFamily: "Public Sans" }}>{chartData?.avgtime?.Count ?? 0}</Typography>
                            </Box>

                            <Box sx={{ borderLeft: "1px solid #E6E6E6", pl: 2 }}>
                                <Typography variant='h6' sx={{ color: "#999999", fontFamily: "Public Sans" }}>Average Repair Time</Typography>
                                <Typography variant='h5' sx={{ color: "#1D013B", fontFamily: "Public Sans" }}>{`${chartData?.avgtime?.hours || 0}H ${chartData?.avgtime?.minutes || 0}M`}</Typography>
                            </Box>

                            <Box sx={{ borderLeft: "1px solid #E6E6E6", pl: 2 }}>
                                <Typography variant='h6' sx={{ color: "#999999", fontFamily: "Public Sans" }}>Queries Solved</Typography>
                                <Typography variant='h5' sx={{ color: "#1D013B", fontFamily: "Public Sans" }}>{chartData?.avgtime?.SolvedQueryCount ?? 0}</Typography>
                            </Box>
                        </Box>

                        <Box sx={{ alignSelf: "flex-end" }}>
                            <CustomMonthPicker
                                date={filters.date}
                                setDate={(date) => setFilters({ ...filters, date })}
                            />
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            width: "100%",
                            height:"38vh",
                            // minHeight: { xs: "35vh", md: "35vh" },
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            p: 2,
                            borderBottom: "2px solid #E6E6E6",
                        }}
                    >
                        <Typography variant="h4" sx={{ fontWeight: 600, color: "#1D013B" }}>
                            {!(filters.city || filters.state || filters?.product_id)
                                ? "Device Wise Queries"
                                : "Device Issues"}
                        </Typography>
                        {!(filters.city || filters.state || filters?.product_id)
                            ? <BarChartComponent chartData={chartData} />
                            : <ProblemWiseDataUi chartData={chartData} />}
                    </Box>

                    <Box display={"flex"} flexDirection={"row"} width={"100%"} height={"100%"}>
                        <Box width={"50%"} height={"100%"} display={"flex"} flexDirection={"column"} gap={2} p={2} sx={{ borderRight: "2px solid #E6E6E6" }}>
                            <Box>
                                <Typography variant='h5' sx={{ color: "#1D013B", fontFamily: "Public Sans", fontWeight: "600" }}>
                                    {filters?.city ? "City Wise Queries" : filters?.state ? "State Wise Queries" : "Region Wise Queries"}
                                </Typography>
                            </Box>
                            <Box>
                                <CountywiseUI chartData={chartData} filters={filters} />
                            </Box>
                        </Box>
                        <Box width={"50%"} height={"100%"} display={"flex"} flexDirection={"column"} gap={2} p={2}>
                            <Box>
                                <Typography variant='h5' sx={{ color: "#1D013B", fontFamily: "Public Sans", fontWeight: "600" }}>
                                    Warranty Analysis
                                </Typography>
                            </Box>
                            <Box>
                                <WarrantyChart chartData={chartData} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Paper>
        </Box>
    )
}

export default AnalysisDashboardUI